import {
  ColumnLayout,
  Box,
  SpaceBetween,
  Form,
  Container,
  Header,
  TextContent,
  Button,
  Modal,
  Grid,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import { MerchantStoreDetailDataSearchRequest } from "../../features/api-interfaces";
import { useGetMerchantStoreDetailDataQuery } from "../../features/api";
import { USER_TYPE } from "../../configs/constants";
import { useCanIShowHook } from "../../app/useCanIShowHook";
import { changeStyle } from "../../utils/format";
import { COMMON_LABELS } from "../default-constants";
import { useEffect } from "react";

const InfoModal = ({
  visible,
  closeDetailModal,
  storeNo,
}: {
  visible: boolean;
  closeDetailModal: Function;
  storeNo: number;
}) => {
  //取得API用のパラメーターの要素
  const params: MerchantStoreDetailDataSearchRequest = {
    storeNo: storeNo,
  };
  const { data, refetch } = useGetMerchantStoreDetailDataQuery(params, {
    skip: params.storeNo === 0,
  });
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);

  // Modalが開くとデータを取り直す
  useEffect(() => {
    if (visible) {
      refetch();
    }
  }, [visible, refetch]);

  const handlerOnDismiss = () => {
    closeDetailModal();
  };

  if (!data) return <></>;
  return (
    <Modal
      onDismiss={handlerOnDismiss}
      visible={visible}
      size="large"
      footer={
        <>
          <Box float="left">
            <Button formAction="none" variant="link" onClick={handlerOnDismiss}>
              {LABELS.CLOSE}
            </Button>
          </Box>
        </>
      }
      header={LABELS.MODAL_STORE_TITLE}
    >
      <form onSubmit={(e) => e.preventDefault()}>
        <SpaceBetween direction="vertical" size="l">
          <Form>
            <SpaceBetween direction="vertical" size="l">
              {data.changedFlag && (
                <>
                  <Box float={"left"} />
                  <Box float={"right"}>
                    <SpaceBetween direction={"horizontal"} size={"xxl"}>
                      <TextContent>
                        <h4>{LABELS.CHANGED_APP}</h4>
                      </TextContent>
                      {data.changeApplyingDate && (
                        <>
                          <TextContent>
                            <h4>
                              {`${COMMON_LABELS.LEFT_PARENTHESIS}${LABELS.ADAPTED_DAY}`}
                            </h4>
                          </TextContent>
                          <TextContent>
                            <p>
                              {`${data.changeApplyingDate}${COMMON_LABELS.RIGHT_PARENTHESIS}`}
                            </p>
                          </TextContent>
                        </>
                      )}
                    </SpaceBetween>
                  </Box>
                </>
              )}
              <Container>
                <SpaceBetween direction="vertical" size="xxs">
                  <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.STORE_NAME}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>
                          {(data.storeNameKana ?? "　") +
                            "　/　" +
                            (data.storeNameAlphabetical ?? "　")}
                        </p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{"　"}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.storeName ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.STATUS}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.contractStatus ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                </SpaceBetween>
              </Container>
              <Container
                header={
                  <Header variant="h2">{LABELS.DETAIL_MERCHANT_TITLE}</Header>
                }
              >
                <SpaceBetween direction="vertical" size="xxs">
                  <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.MERCHANT_NAME}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.merchantName ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.SITE_ID}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.siteId ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                </SpaceBetween>
              </Container>
              <Container
                header={
                  <Header variant="h2">{LABELS.REGISTERED_COMPANY}</Header>
                }
              >
                <ColumnLayout columns={1}>
                  <SpaceBetween direction="vertical" size="xxs">
                    <SpaceBetween direction="horizontal" size="l">
                      <SpaceBetween direction="horizontal" size="l">
                        <ColumnLayout columns={1}>
                          <SpaceBetween direction="vertical" size="xxs">
                            <TextContent>
                              <h4>{LABELS.CORP_NUMBER}</h4>
                            </TextContent>
                            <TextContent>
                              <h4>{LABELS.COMPANY_STYLE}</h4>
                            </TextContent>
                          </SpaceBetween>
                        </ColumnLayout>
                        <ColumnLayout columns={1}>
                          <SpaceBetween direction="vertical" size="xxxs">
                            <TextContent>
                              <p>{data.corporateNumber || "　"}</p>
                            </TextContent>
                            <TextContent>
                              <p>{data.businessStyle ?? "　"}</p>
                            </TextContent>
                          </SpaceBetween>
                        </ColumnLayout>
                      </SpaceBetween>
                      {isDocomoUser ? (
                        <SpaceBetween direction="horizontal" size="l">
                          <ColumnLayout columns={1}>
                            <SpaceBetween direction="vertical" size="xxs">
                              <TextContent>
                                <h4>{LABELS.DUN_NUMBER}</h4>
                              </TextContent>
                              <TextContent>
                                <h4>{LABELS.COMPANY_TYPE}</h4>
                              </TextContent>
                            </SpaceBetween>
                          </ColumnLayout>
                          <ColumnLayout columns={2}>
                            <SpaceBetween direction="vertical" size="xxxs">
                              <TextContent>
                                <p>{data.dunsNumber ?? "　"}</p>
                              </TextContent>
                              <TextContent>
                                <p>{data.legalEntity ?? "　"}</p>
                              </TextContent>
                            </SpaceBetween>
                          </ColumnLayout>
                        </SpaceBetween>
                      ) : (
                        <></>
                      )}
                    </SpaceBetween>
                  </SpaceBetween>
                </ColumnLayout>

                <SpaceBetween direction="vertical" size="xxs">
                  <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.CORP_NAME}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>
                          {(data.companyNameKana ?? "　") +
                            "　/　" +
                            (data.companyNameAlphabetical ?? "　")}
                        </p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{"　"}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.companyName ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.LICENSE_INFORMATION}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.licenseType ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{"　"}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.licenseNumber ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                </SpaceBetween>
              </Container>
              <Container
                header={
                  <Header variant="h2">{LABELS.DETAIL_STORE_TITLE}</Header>
                }
              >
                <SpaceBetween direction="vertical" size="xxs">
                  <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.STORE_NAME}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.storeName ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.STORE_NAME_DETAIL}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.storeNameItemScreenDisplay ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.STORE_ADDRESS_DETAIL}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>
                          {data.storeLocationPostalCode
                            ? changeStyle(data.storeLocationPostalCode ?? "")
                            : LABELS.BLANK_SPACE_ONE}
                        </p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  {data.storeLocationAddressKana && (
                    <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{"　"}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>{data.storeLocationAddressKana ?? "　"}</p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                  )}
                  <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{"　"}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.storeLocationAddress ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.TEL}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.phoneNumber ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.TEL_DETAIL}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.phoneNumberItemScreenDisplay ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.INDUSTRY}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.industryName ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>
                          {COMMON_LABELS.LEFT_PARENTHESIS +
                            LABELS.INDUSTRY_COMMENT +
                            COMMON_LABELS.RIGHT_PARENTHESIS}
                        </h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.industrySupplement ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.CORP_CODE}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.businessCode ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <h4>{LABELS.STORE_CODE}</h4>
                      </TextContent>
                    </SpaceBetween>
                    <SpaceBetween direction="vertical" size="xxs">
                      <TextContent>
                        <p>{data.shopCode ?? "　"}</p>
                      </TextContent>
                    </SpaceBetween>
                  </Grid>
                  {/* Orange項目追加 */}
                  {/*  決済グループID */}
                  {isDocomoUser ? (
                    <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.SETTLEMENT_GROUP_ID}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>{data.settlementGroupId ?? "　"}</p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                  ) : (
                    <></>
                  )}
                </SpaceBetween>
              </Container>
              <Container header={<Header variant="h2">{LABELS.STATUS}</Header>}>
                <SpaceBetween direction="vertical" size="l">
                  <SpaceBetween direction="horizontal" size="l">
                    <ColumnLayout columns={4}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.STATUS}</h4>
                        </TextContent>
                        <TextContent>
                          <h4>{LABELS.START_DATE}</h4>
                        </TextContent>
                        <TextContent>
                          <h4>{LABELS.END_DATE}</h4>
                        </TextContent>
                        <TextContent>
                          <h4>{LABELS.POSTED_MAP}</h4>
                        </TextContent>
                      </SpaceBetween>
                    </ColumnLayout>
                    <ColumnLayout columns={4}>
                      <SpaceBetween direction="vertical" size="xxxs">
                        <TextContent>
                          <p>{data.contractStatus ?? "　"}</p>
                        </TextContent>
                        <TextContent>
                          <p>{data.startDate ?? "　"}</p>
                        </TextContent>
                        <TextContent>
                          <p>{data.endDate ?? "　"}</p>
                        </TextContent>
                        <TextContent>
                          <p>{data.mapPosting ?? "　"}</p>
                        </TextContent>
                      </SpaceBetween>
                    </ColumnLayout>
                  </SpaceBetween>
                </SpaceBetween>
              </Container>
            </SpaceBetween>
          </Form>
        </SpaceBetween>
      </form>
    </Modal>
  );
};
export default InfoModal;
